import React from 'react';

import { Locales } from 'src/lib/constants';
import { ResourcesSearchTemplate } from 'src/templates';
import {
  getResourcesTopicSearchStaticPaths,
  getResourcesTopicSearchStaticProps,
} from 'src/lib/resources-page-data';

const TopicPage = (props) => {
  return <ResourcesSearchTemplate {...props} locale={Locales.EN_US} />;
};

export async function getStaticPaths() {
  return getResourcesTopicSearchStaticPaths({ locale: Locales.EN_US });
}

export async function getStaticProps({ params, preview }) {
  return getResourcesTopicSearchStaticProps({
    locale: Locales.EN_US,
    preview,
    params,
  });
}

export default TopicPage;
